module.exports = __webpack_public_path__ + "img/list21.c8b5dfc1.jpg";